/**
 * Yellow non-US eligibility notice — shown to viewers whose geo lookup
 * resolves outside the US on the rules surfaces (/rules and /sweepstakes).
 *
 * Shared so every rules-style page renders the identical legal band; the
 * caller owns the geo gate (render only when country !== 'US'). Extracted
 * from RulesPage so the wording can't drift between the two pages.
 */
export function NonUsEligibilityNotice() {
  return (
    <div
      role="note"
      className="flex w-full items-center justify-center gap-[10px] rounded-[10px] bg-[rgba(255,209,0,0.05)] px-[16px] py-[10px]"
    >
      <HazardStripes className="hidden h-[15px] w-[92px] shrink-0 sm:block" />
      <p className="flex-1 text-center font-['Arial',sans-serif] text-[clamp(13px,3.2vw,16px)] leading-[1.2] text-[#ffd100]">
        This contest is open to legal U.S. residents only. Entries from outside the United
        States are ineligible to win.
      </p>
      <HazardStripes className="hidden h-[15px] w-[92px] shrink-0 sm:block" />
    </div>
  );
}

/**
 * Inline-rendered yellow hazard-stripe pattern used to flank the non-US
 * notice text. Renders as a small clipped SVG so we don't need a separate
 * /assets PNG/SVG file; the stripe count fills the bounding box.
 */
function HazardStripes({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 92 15" preserveAspectRatio="none" aria-hidden="true" className={className}>
      <defs>
        <pattern id="hazard-stripes" width="14" height="15" patternUnits="userSpaceOnUse" patternTransform="rotate(-25)">
          <rect width="7" height="15" fill="#ffd100" />
          <rect x="7" width="7" height="15" fill="transparent" />
        </pattern>
      </defs>
      <rect width="92" height="15" fill="url(#hazard-stripes)" />
    </svg>
  );
}
